<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>{{ $t('available') }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <vs-avatar
        color="rgb(124, 209, 9)"
        :src="activeUserInfo.photoURL"
        :text="activeUserInfo.displayName"
        width="40"
        height="40"
        class="rounded-full shadow-md cursor-pointer block"
      />

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 15rem">
          <li
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary hover:text-white
            "
            @click="open()"
          >
            <feather-icon icon="LockIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('change_password') }}</span>
          </li>
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="redirectSettings()"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('dashboard_settings')|capitalize }}</span>
          </li> -->
          <li
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary hover:text-white
            "
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('logout') }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-popup-custom
      :title="$t('change_password')"
      color="danger"
      :active.sync="active"
      :buttonCloseHidden="disableClose"
      :persistent="disableClose"
    >
      <vs-alert :active="message_password != ''" color="danger">
        {{ message_password }}
      </vs-alert>
      <vs-alert :active="passwordError" color="danger">
        {{ $t('passwords_do_not_match') }}
      </vs-alert>
      <div>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-2"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="4"
          >
            <label>
              {{ $t('current_password') }}
            </label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <vs-input
              :placeholder="$t('current_password')"
              type="password"
              class="w-full"
              v-model="form.currentPassword"
              autocomplete="off"
            />
          </vs-col>
        </vs-row>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-2"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="4"
          >
            <label>
              {{ $t('new_password') }}
            </label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <vs-input
              :placeholder="$t('new_password')"
              type="password"
              class="w-full"
              v-model="form.newPassword"
              autocomplete="off"
            />
          </vs-col>
        </vs-row>

        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-2"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-w="4"
          >
            <label>
              {{ $t('password_confirmation') }}
            </label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <vs-input
              :placeholder="$t('password_confirmation')"
              type="password"
              class="w-full"
              v-model="form.passwordConfirmation"
              autocomplete="off"
            />
          </vs-col>
        </vs-row>

        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              ref="loadableButton"
              id="change-password-button-loading"
              class="w-full vs-con-loading__container"
              color="primary"
              type="filled"
              @click="submit"
              :disabled="!isFormValid"
              >{{ $t('submit') }}</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              @click="active = false"
              :disabled="disableClose"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import auth from '@/auth/authService'
import user from '@/http/requests/user'
import loading from '@/mixins/Loading.js'
import validate from '@/mixins/Validate.js'
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
export default {
  components: {
    VsPopupCustom,
  },
  data() {
    return {
      active: false,
      message_password: '',
      disableClose: false,
      form: {
        currentPassword: null,
        NewPassword: null,
        password_confirmation: null,
      },
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    isFormValid() {
      return (
        !this.passwordError &&
        this.form.currentPassword !== '' &&
        this.form.newPassword !== '' &&
        this.form.passwordConfirmation !== ''
      )
    },
    passwordError() {
      if (
        this.form.newPassword !== '' &&
        this.form.passwordConfirmation !== ''
      ) {
        return this.form.newPassword !== this.form.passwordConfirmation
      }
      return false
    },
  },
  mounted() {
    this.message_password = ''
    if (Object.keys(this.activeUserInfo).length !== 0) {
      let pua = JSON.parse(localStorage.getItem('pua'))
      if (pua === null) {
        this.message_password = 'Password Expired. Please change your password.'
        this.open(true)
      }
    }
  },
  methods: {
    redirectSettings() {
      console.log(this.$route.path)
      if (this.$route.path !== '/dashboard/settings') {
        this.$router.push('dashboard/settings')
      }
    },
    logout() {
      if (auth.isAuthenticated()) {
        auth.logOut()
        this.$router.push('/login').catch(() => {})
      }
    },
    submit() {
      this.openLoading('change-password-button-loading')
      user
        .updatePassword(this.form)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            //title: '',
            text: `Password Updated`,
          })
          this.closeLoading('change-password-button-loading')

          this.active = false
          this.message_password = ''
          localStorage.setItem('pua', '1')
        })
        .catch((err) => {
          this.closeLoading('change-password-button-loading')
          this.displayErrors(err)
        })
    },
    open(disabled = false) {
      this.active = true
      this.disableClose = disabled
      this.form = {
        currentPassword: null,
        newPassword: null,
        passwordConfirmation: null,
      }
    },
  },
  mixins: [loading, validate],
}
</script>
